import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/thumbs";
import 'swiper/css/scrollbar';
import Swiper, { Navigation, Thumbs, Pagination, Scrollbar } from 'swiper';
// Example
var exampleSlider = new Swiper(".example-slider", {
    modules: [Navigation, Pagination, Scrollbar],
    loop: false,
    effect: 'fade',
    slidesPerView: 1,
    navigation: {
        nextEl: ".arrow-next",
        prevEl: ".arrow-prev"
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        hide: false
    }
});
